import { render } from "./NewPricingProfileModal.vue?vue&type=template&id=3a600a30"
import script from "./NewPricingProfileModal.vue?vue&type=script&lang=js"
export * from "./NewPricingProfileModal.vue?vue&type=script&lang=js"
script.render = render

export default script